import { create } from "zustand";

const useCartStore = create((set) => ({
  items: JSON.parse(localStorage.getItem("cartItems")) || [],
  addToCart: (item) =>
    set((state) => {
      const newItems = [...state.items, item];
      localStorage.setItem("cartItems", JSON.stringify(newItems));
      return { items: newItems };
    }),

  clearCart: () =>
    set(() => {
      localStorage.removeItem("cartItems");
      return { items: [] };
    }),
  // في CartStore.js
  removeItemAtIndex: (index) =>
    set((state) => {
      const updatedItems = state.items.filter((_, i) => i !== index);
      localStorage.setItem("cartItems", JSON.stringify(updatedItems)); // تحديث الـ localStorage بعد الحذف
      return { items: updatedItems };
    }),
}));

export default useCartStore;
